"use client"

import { QueryClient, useMutation } from "@tanstack/react-query"

import { getClient } from "../utils/supabase"

export const signout = async () => {
  const { error } = await getClient().auth.signOut()
  if (error) throw error
}

export default function useSignout(
  { onError, onSuccess }: { onError?: (error: Error) => void; onSuccess?: () => void } = {},
  queryClient?: QueryClient,
) {
  return useMutation({
    mutationFn: signout,
    onError,
    onSuccess: () => {
      if (queryClient) queryClient.resetQueries()
      if (onSuccess) onSuccess()
    },
  }, queryClient)
}
